<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click="(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="40%">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click="(dialogAdd = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="11" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.svg')"
                          ></v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formAdd.pictureUrlPreview"
                            v-if="formAdd.pictureUrlPreview"
                          ></v-img>
                          <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                          <br />
                          <v-file-input
                            required
                            counter
                            show-size
                            :rules="[rules.required]"
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Image"
                            @change="selectImg"
                            v-model="filesAdd"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px">
                            <v-subheader id="subtext"
                              ><b>ชื่อโปรโมชั่น</b></v-subheader
                            >
                          </v-row>
                          <v-row style="height: 65px">
                            <v-text-field
                              v-model="formAdd.promotionName"
                              placeholder="ชื่อโปรโมชั่น"
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px" class="mt-3">
                            <v-subheader id="subtext"
                              ><b>ชื่อรองโปรโมชั่น</b></v-subheader
                            >
                          </v-row>
                          <v-row style="height: 65px">
                            <v-text-field
                              v-model="formAdd.promotionSubName"
                              placeholder="ชื่อรองโปรโมชั่น"
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px" class="mt-3">
                            <v-subheader id="subtext"
                              ><b>รายละเอียด</b></v-subheader
                            >
                          </v-row>
                          <v-row>
                            <v-textarea
                              auto-grow
                              rows="2"
                              name="input-7-4"
                              placeholder="รายละเอียด"
                              counter
                              dense
                              required
                              :rules="[rules.required]"
                              v-model="formAdd.promotionDetails"
                            ></v-textarea>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px" class="mt-3">
                            <v-subheader id="subtext"
                              ><b>วันที่หมดอายุ</b></v-subheader
                            >
                          </v-row>
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                color="primary"
                                v-model="formAdd.promotionExpiryDate"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                required
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="nowDate"
                              v-model="formAdd.promotionExpiryDate"
                              @input="menu1 = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dense
                                color="primary"
                                @click="
                                  (formAdd.promotionExpiryDate = new Date()
                                    .toISOString()
                                    .substr(0, 10)),
                                    (menu1 = false)
                                "
                              >
                                วันที่ปัจจุบัน
                              </v-btn>
                              <v-btn
                                dense
                                color="red"
                                dark
                                @click="
                                  (formAdd.promotionExpiryDate = ''),
                                    (menu1 = false)
                                "
                              >
                                Clear
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col id="margin">
                          <v-row justify="center" id="v-step-1">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              dark
                              :disabled="!validAdd"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="60%">
            <v-card>
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click="(dialogEdit = false), clearDataUpdate()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_edit"
                            :src="require('@/assets/GroupEditTitle.svg')"
                          ></v-img>
                        </v-col>
                        <v-row justify="center">
                          <v-col cols="12" class="text-center">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formUpdate.pictureUrlPreview"
                            ></v-img>
                            <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.resizeImag]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgUpdate"
                              v-model="filesUpdate"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-col cols="12">
                          <v-row style="height: 25px">
                            <v-subheader id="subtext"
                              ><b>ชื่อโปรโมชั่น</b></v-subheader
                            >
                          </v-row>
                          <v-row style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.promotionName"
                              placeholder="ชื่อโปรโมชั่น"
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px" class="mt-3">
                            <v-subheader id="subtext"
                              ><b>ชื่อรองโปรโมชั่น</b></v-subheader
                            >
                          </v-row>
                          <v-row style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.promotionSubName"
                              placeholder="ชื่อรองโปรโมชั่น"
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px" class="mt-3">
                            <v-subheader id="subtext"
                              ><b>รายละเอียด</b></v-subheader
                            >
                          </v-row>
                          <v-row>
                            <v-textarea
                              auto-grow
                              rows="2"
                              name="input-7-4"
                              placeholder="รายละเอียด"
                              counter
                              dense
                              required
                              :rules="[rules.required]"
                              v-model="formUpdate.promotionDetails"
                            ></v-textarea>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 25px" class="mt-3">
                            <v-subheader id="subtext"
                              ><b>วันที่หมดอายุ</b></v-subheader
                            >
                          </v-row>
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formUpdate.promotionExpiryDate"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="nowDate"
                              v-model="formUpdate.promotionExpiryDate"
                              @input="menu2 = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dense
                                color="primary"
                                @click="
                                  (formUpdate.promotionExpiryDate = new Date()
                                    .toISOString()
                                    .substr(0, 10)),
                                    (menu2 = false)
                                "
                              >
                                วันที่ปัจจุบัน
                              </v-btn>
                              <v-btn
                                dense
                                dark
                                color="red"
                                @click="
                                  (formUpdate.promotionExpiryDate = ''),
                                    (menu2 = false)
                                "
                              >
                                Clear
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-row justify="center">
                            <v-btn
                              elevation="2"
                              x-large
                              dark
                              color="#173053"
                              :disabled="!validUpdate"
                              :loading="loadingEdit"
                              @click="editData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="รหัส โปรโมชั่น*"
                        v-model="formUpdate.id"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="formUpdate.promotionName"
                        placeholder="ชื่อโปรโมชั่น"
                        label="ชื่อโปรโมชั่น"
                        dense
                        required
                        readonly
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.promotionExpiryDate`]="{ item }">
                    {{ format_dateNotime(item.promotionExpiryDate) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.promotionPicture`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.promotionPicture" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          x-small
                          dark
                          @click.stop="getDataById(item, 'edit')"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      PK: '',
      path: '/promotion/', // Path Model
      returnLink: '/Master/Promotion',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'โปรโมชั่น',
          disabled: false,
          href: '/Master/Promotion'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      menu1: false,
      menu2: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      filesAdd: null,
      filesUpdate: null,
      nowDate: new Date().toISOString().slice(0, 10),
      formAdd: {
        promotionName: '',
        promotionSubName: '',
        promotionPicture: '',
        promotionDetails: '',
        promotionExpiryDate: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        id: '',
        promotionName: '',
        promotionSubName: '',
        promotionPicture: '',
        promotionDetails: '',
        promotionExpiryDate: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        shopId: ''
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 10 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        resizeImag: (value) =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รูป', value: 'promotionPicture' },
        { text: 'ชื่อโปรโมชั่น', value: 'promotionName' },
        { text: 'ชื่อรองโปรโมชั่น', value: 'promotionSubName' },
        { text: 'รายละเอียด', value: 'promotionDetails' },
        { text: 'วันหมดอายุ', value: 'promotionExpiryDate' },
        { text: 'วันอัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      dataLevel: [],
      // End Data Table Config
      loadingAdd: false,
      loadingEdit: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
  },
  methods: {
    selectImgUpdate () {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg () {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataById (item, type) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.promotionPicture
      if (this.formUpdate.promotionExpiryDate === '') {
        this.formUpdate.promotionExpiryDate = ''
      } else {
        this.formUpdate.promotionExpiryDate = moment(
          String(this.formUpdate.promotionExpiryDate)
        ).format('YYYY-MM-DD')
      }
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    async addData () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/promotion`, params)
            .then(function (response) {
              _this.formAdd.promotionPicture = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearData()
              this.filesAdd = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.id
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)
            await axios
              .post(this.DNS_IP + `/file/upload/promotion`, params)
              .then(function (response) {
                _this.formUpdate.promotionPicture = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.promotionPicture =
              this.formUpdate.pictureUrlPreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['id']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['CREATE_USER']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdate
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false
              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesUpdate = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      this.dataReady = false
      await this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async clearData () {
      this.formAdd.promotionName = ''
      this.formAdd.promotionSubName = ''
      this.formAdd.promotionPicture = ''
      this.formAdd.promotionDetails = ''
      this.formAdd.promotionExpiryDate = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrlPreview = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
    },
    async clearDataUpdate () {
      this.formUpdate.id = ''
      this.formUpdate.promotionName = ''
      this.formUpdate.promotionSubName = ''
      this.formUpdate.promotionPicture = ''
      this.formUpdate.promotionDetails = ''
      this.formUpdate.promotionExpiryDate = ''
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.pictureUrlPreview = ''
      this.formUpdate.shopId = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Master/Promotion.vue